import { Link } from "react-router-dom";
import { Mail, MapPin, MessageCircle, Phone } from "lucide-react";
import Logo from "@/components/Logo";
import { CONTACT, SERVICES } from "@/data/site";

export default function Footer() {
    return (
        <footer className="bg-navy-900 text-slate-300" data-testid="site-footer">
            <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-6 py-16 md:grid-cols-2 lg:grid-cols-4 lg:px-12">
                <div>
                    <Logo dark />
                    <p className="mt-5 text-sm leading-relaxed text-slate-400">
                        Independent civil engineering &amp; construction consultancy. 38 years of practical experience —
                        independent advice, practical assessment, clear documentation.
                    </p>
                    <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.25em] text-amber">
                        Your Construction. Our Expertise.
                    </p>
                </div>

                <div>
                    <h3 className="font-mono text-xs uppercase tracking-[0.2em] text-white">Explore</h3>
                    <ul className="mt-5 space-y-3 text-sm">
                        {[
                            ["About Us", "/about"],
                            ["Services", "/services"],
                            ["Site Inspection", "/site-inspection"],
                            ["BOQ & Bill Review", "/boq-bill-review"],
                            ["How It Works", "/how-it-works"],
                            ["Who We Help", "/who-we-help"],
                            ["FAQ", "/faq"],
                            ["Contact", "/contact"],
                        ].map(([label, to]) => (
                            <li key={to}>
                                <Link
                                    to={to}
                                    className="text-slate-400 transition-colors duration-200 hover:text-amber"
                                    data-testid={`footer-link-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                                >
                                    {label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                <div>
                    <h3 className="font-mono text-xs uppercase tracking-[0.2em] text-white">Services</h3>
                    <ul className="mt-5 space-y-3 text-sm">
                        {SERVICES.slice(0, 6).map((s) => (
                            <li key={s.title}>
                                <Link
                                    to={s.link}
                                    className="text-slate-400 transition-colors duration-200 hover:text-amber"
                                    data-testid={`footer-service-${s.short.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                                >
                                    {s.title}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                <div>
                    <h3 className="font-mono text-xs uppercase tracking-[0.2em] text-white">Contact</h3>
                    <ul className="mt-5 space-y-4 text-sm">
                        <li className="flex items-start gap-3">
                            <MapPin size={16} className="mt-0.5 shrink-0 text-amber" />
                            <span>{CONTACT.person} — {CONTACT.location}</span>
                        </li>
                        <li className="flex items-start gap-3">
                            <Phone size={16} className="mt-0.5 shrink-0 text-amber" />
                            <span>
                                <a href={`tel:+91${CONTACT.phone1}`} className="hover:text-amber" data-testid="footer-phone-1">
                                    +91 {CONTACT.phone1}
                                </a>
                                <br />
                                <a href={`tel:+91${CONTACT.phone2}`} className="hover:text-amber" data-testid="footer-phone-2">
                                    +91 {CONTACT.phone2}
                                </a>
                            </span>
                        </li>
                        <li className="flex items-start gap-3">
                            <Mail size={16} className="mt-0.5 shrink-0 text-amber" />
                            <a href={`mailto:${CONTACT.email}`} className="hover:text-amber" data-testid="footer-email">
                                {CONTACT.email}
                            </a>
                        </li>
                        <li>
                            <a
                                href={CONTACT.whatsapp}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="inline-flex items-center gap-2 border border-slate-700 px-4 py-2.5 font-mono text-[11px] uppercase tracking-[0.16em] text-white transition-colors duration-300 hover:border-[#25D366] hover:text-[#25D366]"
                                data-testid="footer-whatsapp-btn"
                            >
                                <MessageCircle size={14} /> Chat on WhatsApp
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-slate-800">
                <div className="mx-auto flex max-w-7xl flex-col gap-2 px-6 py-5 font-mono text-[11px] uppercase tracking-[0.15em] text-slate-500 sm:flex-row sm:items-center sm:justify-between lg:px-12">
                    <span>© 2026 {CONTACT.business}</span>
                    <span>Independent · Professional · Practical</span>
                </div>
            </div>
        </footer>
    );
}
